module.exports = __webpack_public_path__ + "img/upload-err3.b9305c3e.png";